import React, {Component} from "react";
import DeferredPromise, {createDeferredPromise} from "../../ts/common/DeferredPromise";

export interface IBasicComponentProps
{

}

export default class BasicComponent<P> extends Component<P & IBasicComponentProps, any>
{

    props: Readonly<P & IBasicComponentProps>;
    initialized: boolean = false;
    mounted: boolean = false;
    initialMounted: boolean = false;
    willRequestRefreshState: boolean = false;
    didRequestRefreshState: boolean = false;
    isRendering: boolean = false;
    stateEstablishedPromises:DeferredPromise<void, void>[] = [];
    initialStateEstablished = false;
    isInitializeInvalid:boolean = false;

    constructor(props: P & IBasicComponentProps)
    {
        super(props);
        this.props = props;
    }

    initialize():void {
        this.initVariables();
        this.bindFunctions();
        this.applyNextProps(this.props)
        this.onInitialize();
        this.initialized = true;
    }

    initVariables(): void
    {

    }

    onInitialize(): void
    {

    }

    bindFunctions(): void
    {

    }

    shouldComponentUpdate(nextProps: IBasicComponentProps): boolean
    {
        this.applyNextProps(nextProps, this.props)
        return true;
    }

    applyNextProps(nextProps:IBasicComponentProps, props?:IBasicComponentProps)
    {

    }

    componentDidUpdate(prevProps: IBasicComponentProps)
    {
        this.postRender(prevProps)
    }

    postRender(prevProps: IBasicComponentProps): void
    {
        this.onPostRender();
        if(!this.willRequestRefreshState && !this.isStateWaitingForResponse()){
            if(!this.initialStateEstablished){
                this.onInitialStateEstablished();
            }
            this.onStateEstablished();

            for(let promise of this.stateEstablishedPromises){
                promise.resolve();
            }
            this.stateEstablishedPromises.length = 0;
            this.applyAnimations()
            this.initialStateEstablished = true;
        }
    }

    applyAnimations()
    {

    }

    onInitialStateEstablished()
    {

    }

    onPostRender()
    {

    }

    onStateEstablished()
    {

    }

    wrapComponent(component: React.JSX.Element): React.JSX.Element
    {
        return component;
    }

    componentDidMount()
    {
        this.mounted = true;
        if(!this.initialMounted){
            this.initialMounted = true;
            this.componentDidFirstMount();
        }
        this.postRender(this.props)
    }

    componentDidFirstMount()
    {

    }

    componentWillUnmount()
    {
        this.mounted = false;
        this.stateEstablishedPromises.length = 0;
    }

    refreshState(withDelay:boolean = false): void
    {
        if(!this.mounted){
            return;
        }
        const handleRefresh = () => {
            if(this.didRequestRefreshState){
                return;
            }
            this.willRequestRefreshState = false;
            this.didRequestRefreshState = true;

            this.setState({});
        }
        if(!this.isRendering && !withDelay){
            handleRefresh();
        } else {
            if(!this.willRequestRefreshState){
                this.willRequestRefreshState = true;
                setTimeout(handleRefresh,1)
            }
        }
    }

    isStateWaitingForResponse():boolean
    {
        return false;
    }

    whenNextStateEstablished(): Promise<void>
    {
        const promise:DeferredPromise<void, void> = createDeferredPromise<void, void>();

        this.stateEstablishedPromises.push(promise);
        this.refreshState();
        return promise;
    }

    renderComponent()
    {
        return <></>
    }

    renderInitializeInvalid(): React.JSX.Element
    {
        return <></>
    }

    render()
    {
        this.isRendering = true;
        this.didRequestRefreshState = false;
        if(!this.initialized){
            this.initialize();
        }
        const wrappedComponent = this.wrapComponent(!this.isInitializeInvalid ? this.renderComponent() : this.renderInitializeInvalid());
        this.isRendering = false;
        return wrappedComponent;
    }

}